module.exports = __webpack_public_path__ + "img/header-engagementRingsRingsets.bd96737.webp";